import { Grid, GridProps, Typography } from "@mui/material";
import { JSXElementConstructor, ReactElement } from "react";
import {
  Controller,
  ControllerRenderProps,
  FieldValues,
  useFormContext,
} from "react-hook-form";

interface Props {
  spacing?: number;
  render: (
    field: ControllerRenderProps<FieldValues, string>,
  ) => ReactElement<any, string | JSXElementConstructor<any>>;
  label?: string;
  labelWidth?: number | "auto";
  fieldName: string;
  labelColor?: string;
  inputWidth?: number | "auto";
  GridContainerProps?: GridProps;
  GridFieldProps?: GridProps;
  rules?: Record<string, any>;
}

const DEFAULT_LABEL_WIDTH = 4;
const DEFAULT_INPUT_WIDTH = 8;

const LabelCustomInputRow = ({
  render,
  label,
  labelWidth = DEFAULT_LABEL_WIDTH,
  fieldName,
  labelColor,
  inputWidth = DEFAULT_INPUT_WIDTH,
  rules,
}: Props) => {
  const { control } = useFormContext();

  return (
    <>
      {label && (
        <Grid
          container
          item
          xs={labelWidth}
          justifyContent="flex-end"
          alignItems="center"
        >
          <Typography variant="secondary" color={labelColor}>
            {label}
          </Typography>
        </Grid>
      )}
      <Grid item xs={inputWidth}>
        <Controller
          name={fieldName}
          control={control}
          rules={rules}
          render={({ field }) => render(field)}
        />
      </Grid>
    </>
  );
};

export default LabelCustomInputRow;
